import { api } from './api-client';
import { toQueryString } from './query';
import { ApiResponse, PaginatedResponse, PaginationQuery, UnitMeasure } from '../types/api';

export interface UnitMeasureInput { name: string; abbreviation: string; }
export interface UnitMeasureQuery extends PaginationQuery { active?: boolean; }

export async function listUnitsOfMeasure(query: UnitMeasureQuery = {}) {
  const response = await api.get<PaginatedResponse<UnitMeasure>>(`/units-of-measure${toQueryString(query)}`);
  return response.data;
}
export async function createUnitMeasure(input: UnitMeasureInput) {
  const response = await api.post<ApiResponse<UnitMeasure>>('/units-of-measure', input);
  return response.data.data;
}
export async function getUnitMeasure(id: number) {
  const response = await api.get<ApiResponse<UnitMeasure>>(`/units-of-measure/${id}`);
  return response.data.data;
}
export async function updateUnitMeasure(id: number, input: Partial<UnitMeasureInput>) {
  const response = await api.patch<ApiResponse<UnitMeasure>>(`/units-of-measure/${id}`, input);
  return response.data.data;
}
export async function updateUnitMeasureStatus(id: number, active: boolean) {
  const response = await api.patch<ApiResponse<UnitMeasure>>(`/units-of-measure/${id}/status`, { active });
  return response.data.data;
}
